// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__VzN3I","footer":"App_footer__2SM8G"};